/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  IShelterController,
  IShelterControllerInterface,
} from "../IShelterController";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "shelterId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "newOwnerGuildId",
        type: "uint256",
      },
    ],
    name: "changeShelterOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
    ],
    name: "clearShelter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
    ],
    name: "guildToShelter",
    outputs: [
      {
        internalType: "uint256",
        name: "shelterId",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "shelterId",
        type: "uint256",
      },
    ],
    name: "shelterToGuild",
    outputs: [
      {
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

export class IShelterController__factory {
  static readonly abi = _abi;
  static createInterface(): IShelterControllerInterface {
    return new Interface(_abi) as IShelterControllerInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): IShelterController {
    return new Contract(address, _abi, runner) as unknown as IShelterController;
  }
}
